<template>
  <div class="archivos-wrapper">
    <v-layout row wrap v-if="archivos.length > 0" class="pa-2">
      <v-flex xs6 sm4 md3 v-for="archivo in archivos" :key="archivo.id" class="pa-2">

        <v-card hover class="archivo-card elevation-1" @click="manejarClick(archivo)">

          <div v-if="esImagen(archivo.name)" class="image-preview">
            <v-img :src="archivo.url" aspect-ratio="1" class="grey lighten-3">
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
          </div>

          <div v-else-if="esAudio(archivo.name)" class="file-preview grey lighten-4">
            <v-icon size="48" color="orange darken-1">audiotrack</v-icon>
            <div class="font-weight-bold mt-2 text-uppercase" style="color: #666;">
              AUDIO
            </div>
          </div>

          <div v-else-if="esVideo(archivo.name)" class="file-preview grey lighten-4">
            <v-icon size="48" color="red darken-1">movie</v-icon>
            <div class="font-weight-bold mt-2 text-uppercase" style="color: #666;">
              VIDEO
            </div>
          </div>

          <div v-else class="file-preview grey lighten-4">
            <v-icon size="48" color="primary">insert_drive_file</v-icon>
            <div class="font-weight-bold mt-2 text-uppercase" style="color: #666;">
              {{ getExtension(archivo.name) }}
            </div>
          </div>

          <div class="pa-2 info-footer">
            <div class="text-truncate file-name font-weight-medium" :title="getAttachmentName(archivo.name)">
              {{ getAttachmentName(archivo.name) }}
            </div>
            <div class="grey--text" style="font-size: 0.75em;">
              {{ archivo.autorNombreReal }} - {{ archivo.fecha }}
            </div>
          </div>
        </v-card>

      </v-flex>
    </v-layout>

    <div v-else class="empty-state">
      <v-icon size="64" color="grey lighten-2">folder_open</v-icon>
      <div class="grey--text mt-3" style="font-size: 1.2em;">No hay archivos adjuntos en este chat</div>
    </div>

    <v-dialog v-model="dialogoGaleria" max-width="900" dark>
      <v-card class="black" v-if="dialogoGaleria">

        <!-- <v-btn
          absolute
          left
          style="z-index: 10; top: 12px; left: 20px;"
          @click="irAlMensajeDesdeGaleria"
        >
          <v-icon left>mdi-message-text</v-icon>
          Ir al mensaje
        </v-btn> -->

        <v-btn icon absolute left style="z-index: 10; top: 10px; left: 10px;" @click="irAlMensajeDesdeGaleria" title="Ir al mensaje">
          <v-icon color="white">mdi-message-text</v-icon>
        </v-btn>

        <v-btn icon absolute right style="z-index: 10; top: 10px;" @click="dialogoGaleria = false">
          <v-icon>close</v-icon>
        </v-btn>

        <v-carousel v-model="imagenActualIndex" hide-delimiters height="400" :cycle="false">

          <v-carousel-item v-for="(media, i) in elementosGaleria" :key="i">

            <v-layout fill-height align-center justify-center v-if="esImagen(media.name)">
              <img :src="media.url" style="max-height: 100%; max-width: 100%; object-fit: contain;">
            </v-layout>

            <v-layout fill-height align-center justify-center column v-else-if="esAudio(media.name)">
              <v-icon size="120" color="grey darken-3" class="mb-5">audiotrack</v-icon>
              <audio controls :src="media.url" style="width: 70%; outline: none; border-radius: 30px;"></audio>
              <div class="mt-4 grey--text text-truncate" style="max-width: 70%; font-size: 1.1em;">
                {{ getAttachmentName(media.name) }}
              </div>
            </v-layout>

            <v-layout fill-height align-center justify-center v-else-if="esVideo(media.name)">
              <video controls :src="media.url" style="max-height: 100%; max-width: 100%; outline: none;"></video>
            </v-layout>

          </v-carousel-item>

        </v-carousel>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
export default {
  name: 'ChatArchivos',
  props: {
    mensajes: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      dialogoGaleria: false,
      imagenActualIndex: 0
    }
  },
  computed: {
    archivos () {
      let lista = []
      this.mensajes.forEach(mensaje => {
        if (mensaje.assets && mensaje.assets.length > 0 && mensaje.eliminado === false) {
          mensaje.assets.forEach(asset => {
            lista.push({
              ...asset,
              mensajeId: mensaje.id,
              autorNombreReal: mensaje.autorNombreReal,
              fecha: mensaje.createdNombre
            })
          })
        }
      })
      return lista.reverse()
    },
    elementosGaleria () {
      return this.archivos.filter(a => this.esMedia(a.name))
    }
  },
  methods: {
    esImagen (nombre) {
      if (!nombre) return false
      const extensiones = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp']
      const ext = nombre.substring(nombre.lastIndexOf('.')).toLowerCase()
      return extensiones.includes(ext)
    },
    esAudio (nombre) {
      if (!nombre) return false
      const extensiones = ['.m4a', '.mp3', '.wav', '.ogg', '.aac']
      const ext = nombre.substring(nombre.lastIndexOf('.')).toLowerCase()
      return extensiones.includes(ext)
    },
    esVideo (nombre) {
      if (!nombre) return false
      const extensiones = ['.mp4', '.webm', '.ogg', '.mov']
      const ext = nombre.substring(nombre.lastIndexOf('.')).toLowerCase()
      return extensiones.includes(ext)
    },
    esMedia (nombre) {
      return this.esImagen(nombre) || this.esAudio(nombre) || this.esVideo(nombre)
    },
    getExtension (nombre) {
      if (!nombre || !nombre.includes('.')) return 'FILE'
      return nombre.split('.').pop().substring(0, 4)
    },
    getAttachmentName (name) {
      return name || 'Archivo adjunto'
    },
    manejarClick (archivo) {
      if (this.esMedia(archivo.name)) {
        const index = this.elementosGaleria.findIndex(m => m.id === archivo.id)
        if (index !== -1) {
          this.imagenActualIndex = index
          this.dialogoGaleria = true
        }
      } else {
        window.open(archivo.url, '_blank')
      }
    },
    irAlMensajeDesdeGaleria () {
      const elementoActual = this.elementosGaleria[this.imagenActualIndex]
      if (elementoActual && elementoActual.mensajeId) {
        this.$emit('irAlMensaje', elementoActual.mensajeId)
        this.dialogoGaleria = false
      }
    }
  }
}
</script>

<style scoped>
.archivos-wrapper {
  height: 100%;
  max-height: 600px;
  min-height: 400px;
  overflow-y: auto;
  background-color: #fafafa;
}

.archivo-card {
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s;
}

.archivo-card:hover {
  transform: translateY(-3px);
}

.image-preview {
  width: 100%;
  height: 120px;
  overflow: hidden;
}

.file-preview {
  width: 100%;
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.info-footer {
  background-color: #fff;
  border-top: 1px solid #eeeeee;
}

.file-name {
  font-size: 0.9em;
  color: #333;
}

.empty-state {
  height: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
